import { createSelector } from 'reselect';

import { AppState } from '../../types';
import { StateOrganization, StateListOrganizations } from './types';

export const selectOrganizationList = (state: AppState):StateListOrganizations => state.organizations.list;

export const selectOrganization = (state: AppState):StateOrganization => state.organizations.selected;

export const selectOrganizationForm = (state: AppState):StateOrganization => state.organizations.form;

export const isOrganizationPersistent = createSelector(
  selectOrganization,
  (state) => Boolean(state.data?.id),
);

export const selectOrganizationName = createSelector(
  selectOrganization,
  (state) => state.data?.common_name,
);
